import Vue from 'vue'
import Error from '../kne/error'
import store from '../store'
import {errorLocale} from '../kne/de-error'

// Lib imports
import axios from 'axios'




axios.interceptors.request.use((config: any): any => {
  //console.log(["All requests", config])
  store.commit("core/startIsLoading")
  // @ts-ignore
  if(store.state.user.accessToken !== ""){
    // @ts-ignore
    config.headers["Authorization"] = 'Bearer ' + store.state.user.accessToken
  }
  return config
}, (error) => {
  store.commit("core/stopIsLoading");
  console.error(["Axios interceptor request error", error])
  return Promise.reject(error)
})

axios.interceptors.response.use((response: any): any => {
  //console.log(["All Responses", response])
  store.commit("core/stopIsLoading");
  return response
}, (error) => {
  if (error.response.data.isErrorResponse === true) {
    console.error(["errorMessage", "errorMessage"])
    const code: string = error.response.data.errorCode.toString();

    // Handle error responses
    console.error(["Axios response error message", error.response.data])
    // @ts-ignore
    const errorMessage: string = errorLocale.data["ERROR"][code];
    console.error([code, errorMessage])
    store.commit('snackbar/showSnackbar', errorMessage)
  }

  store.commit("core/stopIsLoading");
  console.error(["Axios interceptor response error", error])
  return Promise.reject(error)
})

Vue.prototype.$http = axios
